import styled from 'styled-components'

export const PrivateCompanyIndicatorWrapper = styled('div')`
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
  justify-content: center;
`
